import { render, staticRenderFns } from "./PayerBarChart.vue?vue&type=template&id=5c97cdea&scoped=true"
import script from "./PayerBarChart.vue?vue&type=script&lang=js"
export * from "./PayerBarChart.vue?vue&type=script&lang=js"
import style0 from "./PayerBarChart.vue?vue&type=style&index=0&id=5c97cdea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97cdea",
  null
  
)

export default component.exports